module.exports = __webpack_public_path__ + "static/media/banglore to pune.deeb1b94.jpg";